import { Link } from "react-router-dom";
import {
  Box,
  Container,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";
import YouTubeIcon from "@mui/icons-material/YouTube";
import logo from "../../images/logo_no_bg.png";

import "./Footer.css";
import "./responsive.css";

function Footer() {
  return (
    <Box component="footer" className="app-footer">
      <Container maxWidth="lg" className="app-footer__top">
        <Box className="app-footer__brand">
          <Link to="/home" aria-label="Грамота, головна сторінка">
            <img alt="Грамота" src={logo} />
          </Link>
          <Typography>
            Платформа електронних додатків для навчання та перевірки знань.
          </Typography>
        </Box>

        <Stack className="app-footer__contacts" spacing={1}>
          <Typography variant="subtitle2">Контакти</Typography>
          <a href="tel:+380686604958"><PhoneIphoneRoundedIcon />+38 068 660 49 58</a>
          <a href="mailto:info@gramota.kiev.ua"><EmailOutlinedIcon />info@gramota.kiev.ua</a>
        </Stack>

        <Stack className="app-footer__social" spacing={1}>
          <Typography variant="subtitle2">Приєднуйтесь</Typography>
          <Stack direction="row" spacing={1}>
            <IconButton aria-label="Facebook" className="app-footer__social-facebook">
              <FacebookRoundedIcon />
            </IconButton>
            <IconButton aria-label="YouTube" className="app-footer__social-youtube">
              <YouTubeIcon />
            </IconButton>
            <IconButton aria-label="Instagram" className="app-footer__social-instagram">
              <InstagramIcon />
            </IconButton>
          </Stack>
        </Stack>
      </Container>

      <Box className="app-footer__bottom">
        <Container maxWidth="lg" className="app-footer__bottom-inner">
          <Typography variant="body2">© {new Date().getFullYear()} е-Грамота. Усі права захищено.</Typography>
          <Stack direction="row" spacing={3} className="app-footer__policy">
            <a href="/about">Політика конфіденційності</a>
            <a href="/about">Умови використання</a>
          </Stack>
          <IconButton
            component="a"
            href="https://www.gramota.kiev.ua"
            target="_blank"
            rel="noreferrer"
            aria-label="Сайт видавництва"
          >
            <LanguageRoundedIcon />
          </IconButton>
        </Container>
      </Box>
    </Box>
  );
}

export default Footer;
